import React from 'react'
import TableBody from './audit-table-body'
import styles from '../component-styles/audit-table.module.scss'
import Heading from './heading'
import Loader from './loader'

interface Props {
  type: 'passed' | 'failed'
  tableData: AuditTableEntry[]
  toggleActive: (title: string) => void
}

export default function AuditTable({
  type,
  tableData,
  toggleActive,
}: Props): React.ReactElement {
  if (tableData.length <= 0) {
    return (
      <Loader>
        <Loader minHeight="40px" light />
        <Loader minHeight="40px" light />
        <Loader minHeight="40px" light />
        <Loader minHeight="40px" light />
      </Loader>
    )
  }

  return (
    <>
      <Heading type={4} align="left" className={styles.heading}>
        {type === 'passed' ? 'Passed tests' : 'To fix'}
      </Heading>
      <section className={styles.container}>
        <TableBody data={tableData} type={type} toggleActive={toggleActive} />
      </section>
    </>
  )
}
